module.exports = __webpack_public_path__ + "img/6.9292b2e8.png";